// Entry point for the login/terms layouts. Mirrors the former Sprockets
// manifest app/assets/javascripts/login.js.
import "./lib/jquery.js"
import "./vendor/jquery_ujs.js"
import "./vendor/bootstrap_2_3_2.js"
